import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import './style.scss';
import './mobile.scss';
import _ from 'lodash';

const PartnersList = (props) => {
  const groupedList = _.groupBy(props.collection || [], 'year')
  return (
    <>
      <div className='partners-list'>
        {
          Object.entries(groupedList).map(([year, partners]: any) => {
            return (
              <div className='partners__section' key={year}>
                <h3>{year}</h3>
                <ul className='partners__list'>
                  {
                    partners.map((partner) => {
                      return (
                        <li className='partners__list-item' key={partner.id}>
                          <div className="partners__list-item-image">
                            <a
                              href={partner.image?.image}
                              target="_blank" className="loaded">
                              <img alt="" src={partner.image?.big_image_url} />
                            </a>
                          </div>
                          <div className="partners__list-item-name">{partner.name}</div>
                          <div className="partners__list-item-title">
                            {partner.city}, {partner.year}
                          </div>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            )
          })
        }
      </div>
    </>
  );
}

export const
  mapStateToProps = ({applicationState}) => {
    return {
      applicationState
    };
  },

  withConnect = connect(
    mapStateToProps
  );

export default compose(withConnect)(PartnersList);
